export default {
    namespaced: true,
    state: {
        set: null,
        errors: {
            getSet: {}
        }
    },
    mutations: {
        SET_SET(state, payload) {
            state.set = payload
        },
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        }
    },
    actions: {
        async getSet({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'getSet',
                val: {}
            })

            commit('SET_SET', null)

            const url = `/supplier/sets/${data.id}`

            try {
                const resp = await this.$axios.get(url)
                commit('SET_SET', resp.data)
            } catch (e) {
                if (e.response && e.response.data) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getSet',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getSet',
                        val: { error: 'Ошибка' }
                    })
                }
            }
        }
    }
}
